

let mapLinkJQ = $(".map-link");
let banner = $(".banner");
let curatedAllProducts = $(".product-inner-images");
let loading = $(".loading");
let collabrators = $(".collabrators-inner-profile");



if (mapLinkJQ.length == 1 && $(window).width() > 992) {
    let mouseCursor = document.querySelector('.cursor');
    let mapLink = document.querySelector('.map-link');

    window.addEventListener('mousemove', cursor);

    function cursor(e) {
        mouseCursor.style.top = e.pageY + 'px';
        mouseCursor.style.left = e.pageX + 'px';
    }

    mapLink.addEventListener('mouseleave', () => {
        mouseCursor.classList.remove("link-grow");
    });
    mapLink.addEventListener('mouseover', () => {
        mouseCursor.classList.add("link-grow");
    });
}

if (banner.length == 1 && $(window).width() > 992) {
    let videoMouseCursor = document.querySelector('.cursor-video');
    let videoCursorSec = document.querySelector('.banner');
    let discoverBtn = document.querySelector('.discover-more');
    let soundIcon = document.querySelector('.audio_btn');

    window.addEventListener('mousemove', cursor);

    function cursor(e) {
        videoMouseCursor.style.top = e.pageY + 'px';
        videoMouseCursor.style.left = e.pageX + 'px';
    }

    videoCursorSec.addEventListener('mouseleave', () => {
        videoMouseCursor.classList.remove("video-cursor-grow");
    });
    videoCursorSec.addEventListener('mouseover', () => {
        videoMouseCursor.classList.add("video-cursor-grow");
    });


    discoverBtn.addEventListener('mouseleave', () => {
        videoMouseCursor.classList.remove("discover-btn-cursor");
    });
    discoverBtn.addEventListener('mouseover', () => {
        videoMouseCursor.classList.add("discover-btn-cursor");
    });


    soundIcon.addEventListener('mouseleave', () => {
        videoMouseCursor.classList.remove("sound_icon_hovered");
    });
    soundIcon.addEventListener('mouseover', () => {
        videoMouseCursor.classList.add("sound_icon_hovered");
    });

}

if (curatedAllProducts.length == 1 && $(window).width() > 992) {
    let enquireBtn = document.querySelector('.enquire-cursor');
    let videoCursorSec = document.querySelector('.enquire_btn');

    window.addEventListener('mousemove', cursor);

    function cursor(e) {
        enquireBtn.style.top = e.pageY + 'px';
        enquireBtn.style.left = e.pageX + 'px';
    }

    videoCursorSec.addEventListener('mouseleave', () => {
        enquireBtn.classList.remove("enquireGrow");
    });
    videoCursorSec.addEventListener('mouseover', () => {
        enquireBtn.classList.add("enquireGrow");
    });


}

if (collabrators.length == 1 && $(window).width() > 992) {
    let enquireBtn = document.querySelector('.enquire-cursor');
    let videoCursorSec = document.querySelector('.enquire_btn');

    window.addEventListener('mousemove', cursor);

    function cursor(e) {
        enquireBtn.style.top = e.pageY + 'px';
        enquireBtn.style.left = e.pageX + 'px';
    }

    videoCursorSec.addEventListener('mouseleave', () => {
        enquireBtn.classList.remove("enquireGrow");
    });
    videoCursorSec.addEventListener('mouseover', () => {
        enquireBtn.classList.add("enquireGrow");
    });


}



if (loading.length == 1) {
    let lading_text = document.querySelector('.loading-text');
    let loading_wall = document.querySelector('.loading');

    window.addEventListener('mousemove', cursor);

    function cursor(e) {
        lading_text.style.top = e.pageY + 'px';
        lading_text.style.left = e.pageX + 'px';
    }

    loading_wall.addEventListener('mouseleave', () => {
        lading_text.classList.remove("loaing_text_cursor");
    });
    loading_wall.addEventListener('mouseover', () => {
        lading_text.classList.add("loaing_text_cursor");
    });


}